import { createModalContext } from '#/features/modal';

export const [
  UsernamePromptModalProvider,
  useUsernamePromptModalView,
  useUsernamePromptModalActions,
] = createModalContext('UsernamePrompt');
